import SeoHead from '../../components/SeoHead';
import React, { useState, useEffect } from 'react';
import { Jobs, JobsCategory, Global } from "@sourceflow-uk/sourceflow-sdk";
import SubBanner from '../../components/SubBanner';
import JobDetails from '../../components/JobDetails';
import Header from '../../components/MainHeader';
import GoogleJobSchema from "../../components/GoogleJsonData";
import Link from 'next/link';
import Branches from '../../.sourceflow/branches.json'

export default function jobPage({
  global,
  job,
  sector,
  job_type,
  base_salary_range,
  similarJob,
  branchId
}) {

  return (
    <>
      <SeoHead
        // site_name={`Driving Force`}
        page_name={`${job.title}`}
        // description={``}
        canonical_link={`/jobs/${job.url_slug}/`}
      />
      <Header
        employerNav={false}
      />
      <SubBanner
        global={global}
        pathPrefix={`job_page.sub_banner`}
        customClass={`mb-5 secondary-banner`}
        buttonTitle={`Job search`}
        buttonLink={`/jobs/`}
        consultantPage={false}
        heading={`${job.title}`}
        post={job}
        branchId={branchId}
        jobType={job_type}
        jobApplyButtonText={`Apply now`}
        jobPage={true}
      />
      <GoogleJobSchema
        job={job}
        job_type={job_type}
        job_currency={`GBP`}
        job_payment_type={`YEAR`}
        site_name={`Gap Personnel`}
        site_domain_link={`https://www.gap-personnel.com/`}
        site_google_logo_link={`https://www.gap-personnel.com/site-assets/images/google-logo.jpg`}
      />
      <JobDetails
        global={global}
        pathPrefix={`job_page.job_details`}
        customClass={``}
        job={job}
        heading={`Job description`}
        leftHeading={`Job details`}
        sector={sector}
        job_type={job_type}
        base_salary_range={base_salary_range}
        similarJob={similarJob}
        branchId={branchId}
        sub_content={
          <>
            <p>gap personnel is committed to the selection, recruitment and development of the best people, basing judgements solely on suitability for the job</p>
            <p>Whilst we endeavor to respond to all applications individually, due to high volumes, this is not always possible. Thank you for your interest in this role and we look forward to working with you in the future</p>
            <p>By applying for the above position and providing your personal data to us you understand that your data will be processed in line with our <Link href="/privacy-policy/">Privacy Policy</Link></p>
          </>
        }
      />
    </>
  );
}



export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();

  const job = (await Jobs()).getJsonItem(params.slug, 'url_slug');

  const currentjob = await Jobs();
  const internalcategory = currentjob.getItems().find(j => j.url_slug === params.slug);

  // Checks sector category
  const getIndexedValues = async function (categoryName) {
    const category = await JobsCategory(categoryName)
    return [category, category.items.reduce((previous, value) => ({ [value.id]: value, ...previous }), {})]
  }

  const sectorCategory = await getIndexedValues('Specialisms');
  const baseSalaryRangeCategory = await getIndexedValues('Base Salary Range');
  const jobTypeCategory = await getIndexedValues('Contract Type');

  // const jobSectorIds = internalcategory.categories.find((cat) => cat.id === sectorCategory[0].id)?.values || []
  const jobSectorIds = internalcategory.categories.find((cat) => cat.id === sectorCategory[0].id)?.values || []
  const baseSalaryRangeSectorIds = internalcategory.categories.find((cat) => cat.id === baseSalaryRangeCategory[0].id)?.values || []
  const jobTypeSectorIds = internalcategory.categories.find((cat) => cat.id === jobTypeCategory[0].id)?.values || []

  // const jobSector = jobSectorIds.map((id) => sectorCategory[1][id]?.title?.en + " " || null)
  const jobSector = jobSectorIds.map((cat) => sectorCategory[1][cat.id] ? sectorCategory[1][cat.id].title?.en + ", " || null : null);
  const baseSalaryRange = baseSalaryRangeSectorIds.map((cat) => baseSalaryRangeCategory[1][cat.id]?.base_salary_range?.en || null)
  const jobType = jobTypeSectorIds.map((cat) => jobTypeCategory[1][cat.id]?.label?.en + ", " || null)

  let displayInternalForm = false;
  let internalJob = internalcategory.categories
    // Checks if contains Internal Job Category
    .find((cat) => cat.id?.includes("eabbc9bc-c6e8-4bd0-861d-b129f5218f97"));

  if (internalJob !== undefined) {
    displayInternalForm = true;

  } else {
    internalJob = false;
  }

  // Get all jobs with the same sector category values as the current job
  let similarJob;
  // Internal Category ID
  const internalJobCategoryId = "eabbc9bc-c6e8-4bd0-861d-b129f5218f97";
  if (displayInternalForm) {
    similarJob = (await Jobs()).getItems()
      .filter((post) => post.url_slug !== job.url_slug
        && post.categories?.find((cat) => cat.id === internalJobCategoryId))
      .filter(function (job) {
        return (
          (new Date(job?.expires_at)) >= (new Date())
        )
      })
      .slice(0, 6);

  } else {
    similarJob = (await Jobs()).getItems()
      .filter((post) => post.url_slug !== job.url_slug
        //This ID is the Specialisms category ID
        && post.categories?.find((cat) => cat.id === '3a20dd80-6b03-4bf4-b611-b51819c37094'
          && cat.values?.find((value) => jobSectorIds.map((cat) => cat.id).includes(value.id))))

      .filter(function (job) {
        return (
          (new Date(job?.expires_at)) >= (new Date())
        )
      })
      .slice(0, 6)
  }

  // console.log(sectorCategory[0].items.map((cat) => cat.id));
  // console.log(jobSectorIds.map((cat) => cat.id))


  const branchUuid = internalcategory.categories.find(cat => cat.id == "a02302e8-e32b-48d0-9e3a-48f8b7d4026e")?.values[0]?.id
  const branchId = Branches.category_values?.find(val => val.id == branchUuid)?.branch_id?.en || null


  return {
    props: {
      global,
      job: job,
      sector: jobSector,
      job_type: jobType,
      base_salary_range: baseSalaryRange,
      similarJob,
      branchId
    }, // will be passed to the page component as props
  }
}


export async function getStaticPaths() {
  const jobs = await Jobs();
  const jobsSlugs = jobs.map('url_slug').getItems();

  const paths = jobsSlugs.map((jobSlug) => ({
    params: {
      slug: jobSlug
    },
  }))

  return {
    paths,
    fallback: false
  }
}